<template>
  <div id="contenedor-adjudicaciones-toolbar">
    <v-toolbar
    flat
    dense>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
          v-model="filtros.ejercicio"
          class="mr-2"
          sinPeriodo>
        </ejercicio-picker>
    </div>
    <div
      style="width: 350px"
      class="mr-2">
      <custom-text-field
        label="Buscar en la pagina..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <filtros
    :filtros="filtros">
    </filtros>
    <v-spacer></v-spacer>
    <registrar-nueva-adjudicacion></registrar-nueva-adjudicacion>
  </v-toolbar>
  </div>
</template>

<script>
import RegistrarNuevaAdjudicacion from '@/components/administracion/adjudicaciones/Nueva.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ToolBarAdjudicaciones',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    Filtros,
    RegistrarNuevaAdjudicacion,
    CustomTextField,
    EjercicioPicker,
  },
  data() {
    return {};
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevaLicitacion');
    },
  },

};
</script>

<style lang="scss">

</style>
